import { app } from "./firebase";
import {getFirestore} from "firebase/firestore"
import { getStorage } from "firebase/storage";


export const fireStorage = getStorage(app);


export const firestore = getFirestore(app)